import React from 'react'
import { useParams } from 'react-router-dom'
import { Header } from '../components/Header'
import { CategoryFilter } from '../gallery/CategoryFilter'
import { ExampleCard } from '../gallery/ExampleCard'
import { getExamplesByCategory, getCategoryBySlug } from '../gallery/registry'
import type { CategorySlug } from '../gallery/types'
export function GalleryPage() {
  const { categorySlug } = useParams<{ categorySlug: string }>()
  const validSlug = categorySlug && getCategoryBySlug(categorySlug) ? (categorySlug as CategorySlug) : undefined
  const examples = getExamplesByCategory(validSlug)
  const category = validSlug ? getCategoryBySlug(validSlug) : undefined

  return (
    <div className="h-[calc(100vh-2rem)] flex flex-col bg-gray-50">
      <Header page="gallery" />

      <main className="flex-1 overflow-y-auto">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="mb-6">
            <h1 className="text-xl font-bold text-gray-900 mb-1">
              {category ? category.label : 'Animation Examples'}
            </h1>
            <p className="text-sm text-gray-500">
              {category ? category.description : '17 pre-built animation patterns using Motion for React'}
            </p>
          </div>

          <div className="mb-6">
            <CategoryFilter activeSlug={validSlug} />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {examples.map((example) => (
              <ExampleCard key={example.id} example={example} />
            ))}
          </div>

          {examples.length === 0 && (
            <div className="text-center py-16 text-gray-400 text-sm">
              No examples found for this category.
            </div>
          )}
        </div>
      </main>

      <footer className="border-t border-gray-200 bg-white shrink-0">
        <div className="px-4 sm:px-6 lg:px-8 py-3">
          <p className="text-xs text-gray-500 text-center">
            Built with{' '}
            <a
              href="https://motion.dev"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-700 hover:text-gray-900 underline"
            >
              Motion
            </a>
            {' '}by{' '}
            <a href="/" className="text-gray-700 hover:text-gray-900 underline">
              Nimble Labs
            </a>
          </p>
        </div>
      </footer>
    </div>
  )
}
